import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterBankSearch = () => {
  const bankSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-bank/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { bankSearch }
}

export default InteractorMasterBankSearch
